export default __webpack_public_path__ + "static/media/linea-ecommerce-10.0997fc98.svg";